import { Helmet } from 'react-helmet-async';
// @mui
import {Grid, Button, Container, Stack, Typography, TextField, InputAdornment, CircularProgress} from '@mui/material';
// components
import Iconify from '../../components/iconify';
import { useMutation, useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import {GET_ALL_PAGINATED_STATUS_REPORT, GET_ALL_STATUS_REPORT_REQUEST} from 'src/graphql/queries/statusReport';
import LoadingCards from 'src/components/loading-cards/LoadingCards';
import { useSnackbar } from 'notistack';
import StatusReportRequestCard from 'src/sections/@dashboard/status report/StatusReportRequestCard';
import { UPADATE_STATUS_REPORT_STATUS } from 'src/graphql/mutations/statusReport';
import {GET_ALL_ANNUAL_RETURN_REQUEST_PAGINATED} from "../../graphql/queries/annualReturn";
import {debounce} from "lodash";
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

export default function AdminStatusReport() {
  const [page, setPage] = useState(1);
  const pageSize = 10;
  const { data: data2, loading: loadingData2, fetchMore } = useQuery(GET_ALL_PAGINATED_STATUS_REPORT, {
    variables: { page, pageSize },
  });

  const { data, loading: loadingData } = useQuery(GET_ALL_STATUS_REPORT_REQUEST);

  const [bankAccountRequests, setBankAccountRequests] = useState([]);
  const [updateStatus, setUpdateStatus] = useState(false);

  const [updateStatusReportApprovalStatus, { data: updatedReservation, loading }] =
    useMutation(UPADATE_STATUS_REPORT_STATUS);

  const { enqueueSnackbar } = useSnackbar();
  const [filtered, setFiltered] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchLoading, setSearchLoading] = useState(false);

  useEffect(() => {
    if (data2 && data2?.allPaginatedStatus) {
      setBankAccountRequests(data2.allPaginatedStatus.returns);
    }
  }, [data2]);

  useEffect(() => {
    setFiltered(bankAccountRequests);
  }, [bankAccountRequests,]);

  useEffect(() => {
    if (updatedReservation?.updateStatusReportApprovalStatus && updateStatus) {
      setUpdateStatus(false);
      //Initailize array of objects.
      let tempReservations = [...bankAccountRequests];

      //Find index of specific object using findIndex method.
      const objIndex = tempReservations.findIndex(
        (obj) => obj._id === updatedReservation?.updateStatusReportApprovalStatus?._id
      );

      //Update object's name property.
      tempReservations[objIndex].status = updatedReservation?.updateStatusReportApprovalStatus?.status;
      tempReservations[objIndex].adminMessage = updatedReservation?.updateStatusReportApprovalStatus?.adminMessage;

      //Log object to console again.
      setBankAccountRequests(tempReservations);
    }
  }, [updatedReservation?.updateStatusReportApprovalStatus, bankAccountRequests, updateStatus]);

  const changeStatus = (_id, status, adminMessage = '') => {
    setUpdateStatus(true);
    enqueueSnackbar('Status updated!');
    updateStatusReportApprovalStatus({
      variables: { input: { _id, status, adminMessage: [adminMessage] } },
    });
  };


  const handlePageChange = async (newPage) => {
    setPage(newPage);
    await fetchMore({
      variables: { page: newPage, pageSize, searchTerm },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev;
        return fetchMoreResult;
      },
    });
  };

  const handleSearchDebounced = debounce(async (newSearchTerm) => {
    setSearchTerm(newSearchTerm);
    setPage(1);
    setSearchLoading(true);
    await fetchMore({
      variables: { page, pageSize, searchTerm: newSearchTerm },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev;
        console.log({fetchMoreResult, newSearchTerm} )
        return fetchMoreResult;
      },
    });
    setSearchLoading(false);

  }, 200);

  const handleSearchChange = (event) => {
    const newSearchTerm = event.target.value;
    setSearchTerm(newSearchTerm);
    setSearchLoading(false);
    handleSearchDebounced(newSearchTerm);
  };


  return (
    <>
      <Helmet>
        <title> Admin Bank Account | BeeBot </title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Status Report Submission
          </Typography>
          <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />}>
            New Record
          </Button>
        </Stack>

        <Grid container spacing={3}>
          <Grid item md={12} sm={12}>
            <TextField
                value={searchTerm}
                fullWidth
                placeholder="Search Reservation by Company name..."
                onChange={handleSearchChange}
                InputProps={{
                  endAdornment: (
                      <InputAdornment position="end">
                        {searchLoading && <CircularProgress size={20} />}
                      </InputAdornment>
                  ),
                }}
            />
          </Grid>

          {filtered?.map((post, index) => (
            <StatusReportRequestCard
              key={post._id}
              post={post}
              index={index}
              loading={loading}
              changeStatus={changeStatus}
            />
          ))}
          <Grid item md={12} sm={12} container justifyContent="center" alignItems="center" spacing={2}>
            <Grid item>
              <Button variant="outlined" onClick={() => handlePageChange(page - 1)} disabled={page <= 1 || loadingData2}>
                Previous
              </Button>
            </Grid>
            <Grid item>
              <Typography variant="body2">Page {page}</Typography>
            </Grid>
            <Grid item>
              <Button
                  variant="outlined"
                  onClick={() => handlePageChange(page + 1)}
                  disabled={page >= data2?.allPaginatedStatus.pageInfo?.totalPages || loadingData2}
              >
                Next
              </Button>
            </Grid>
            {loadingData2 && <CircularProgress size={24} />}
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
